module.exports = __webpack_public_path__ + "img/payment-icon-paypal.074279dd.svg";